import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import NavLink from './link/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import { getLinkVariations } from 'components/shared/sidebar/utils';
import { objectHasProperty } from 'helpers/utilities';
import { useTranslation } from 'react-i18next';
export default function Sidebar(_a) {
    var _b = _a.type, type = _b === void 0 ? SIDEBAR_MODE_PLAYER : _b;
    var isBank = useSelector(function (state) { return state.player.company.isBank; });
    var playerId = useSelector(function (state) { return state.player.id; });
    var companyId = useSelector(function (state) { return state.player.company.id; });
    var taskSettings = useSelector(function (state) { return state.game.taskSettings; });
    var t = useTranslation().t;
    var windowPath = window.location.pathname;
    var _c = useState(windowPath), activePath = _c[0], setActivePath = _c[1];
    function renderLinks(t) {
        var sidebarLinksVariation = getLinkVariations({
            variables: { playerId: playerId, companyId: companyId, t: t },
            conditions: { isBank: isBank, tasksPresent: (taskSettings === null || taskSettings === void 0 ? void 0 : taskSettings.playerCards) || (taskSettings === null || taskSettings === void 0 ? void 0 : taskSettings.companyCards) }
        })[type];
        if (sidebarLinksVariation) {
            return (React.createElement(Fragment, null, sidebarLinksVariation.map(function (singleLink) {
                var hasCondition = objectHasProperty(singleLink, 'condition');
                var isConditionMet = (hasCondition && singleLink.condition) || !hasCondition;
                return isConditionMet ? (React.createElement(NavLink, { key: singleLink.key, onLinkClick: function () { return setActivePath(activePath); }, to: singleLink.to, icon: singleLink.icon }, singleLink.text)) : null;
            })));
        }
    }
    return React.createElement("div", { className: "sidebar" }, renderLinks(t));
}
